import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from '../Header/Header';
import Sidebar from '../Sidebar/Sidebar';
import './Layout.css';

const Layout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  };

  // Get dynamic title based on current route
  const getPageTitle = () => {
    const path = location.pathname;
    if (path === '/dashboard' || path === '/') return 'Dashboard';
    if (path === '/salesperson') return 'Sales Person';
    if (path === '/wholesaleuser') return 'Wholesale User';
    if (path === '/retailusers') return 'Retail Users';
    if (path === '/order') return 'Order';
    if (path === '/categories') return 'Category';
    if (path === '/product') return 'Product';
    if (path === '/brand') return 'Brand';
    if (path === '/banner') return 'Banner';
    if (path === '/videos') return 'Videos';
    if (path === '/broadcast-notification') return 'Broadcast Notification';
    if (path === '/country') return 'Country';
    if (path === '/state') return 'State';
    if (path === '/city') return 'City';
    if (path === '/pincode') return 'Pincode';
    if (path === '/supportticket') return 'Support Ticket';
    if (path === '/support-chat') return 'Support Chat';
    if (path === '/generalsetting') return 'General Setting';
    if (path === '/bankdetails') return 'Bank Details';
    if (path === '/report') return 'Report';
    if (path === '/chat') return 'Chat';
    if (path === '/all-users') return 'All Users';
    if (path === '/chat-conversation') return 'Chat';
    if (path === '/promo-text') return 'Promo Text';
    if (path === '/announcement-marquee') return 'Announcement Marquee';
    if (path === '/social-media') return 'Social Media';
    
    // Handle add-product with categoryId
    if (path.startsWith('/add-product')) {
      return 'Add Product';
    }
    

    if (path.startsWith('/edit-product/')) {
      return `Edit Product`;
    }
    if (path.startsWith('/order-details/')) {
      return `Order Details`;
    }
    
    if (path.startsWith('/product-details/')) {
      return `Product Details`;
    }
    if (path.startsWith('/product-rating-review/')) {
      return `Product Rating Review`;
    }
    if (path.startsWith('/product-image-upload/')) {
      return `Upload Images`;
    }
    
    const pathSegments = path.split('/').filter(segment => segment);
    if (pathSegments.length > 0) {
      const lastSegment = pathSegments[pathSegments.length - 1];
      return lastSegment.charAt(0).toUpperCase() + lastSegment.slice(1).replace(/([A-Z])/g, ' $1');
    }
    
    return 'Dashboard';
  };

  return (
    <div className="layout">
      <Header 
        onMenuToggle={toggleSidebar} 
        isMenuOpen={isSidebarOpen} 
        title={getPageTitle()}
      />
      <Sidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
      
      <main className={`main-content ${isSidebarOpen ? 'sidebar-open' : ''}`}>
        <div className="content-wrapper">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout; 